module.exports = __webpack_public_path__ + "media/images/page/top/top_bg_01-e782b564278d3264e46687af275ed2a6.png";